import { Component } from '@angular/core';
import { ButtonComponent, ButtonOption } from "../../component/layout/element/button.component";
import { MatSnackBar } from '@angular/material/snack-bar';
import { errorMsgConfig } from '../../../../globalTypes/base.types';
import { CommonErrorComponent } from '../../component/error/common-error.component';
import { Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { authUserFeature } from '../../store/authUser.store';
import { lastValueFrom, take } from 'rxjs';

@Component({
  selector: 'msh-home',
  standalone: true,
  template: `
    <div class="hero-image flex flex-col items-center text-center ">

      <img [src]="'MobileStorehouse_logo_landscape-reverse.png'" 
           alt="Mobile Storehouse Logo" 
           class="max-w-xs sm:max-w-lg mb-6 mt-16" />

      <h1 class="text-3xl sm:text-4xl font-bold text-heavy-copy mb-2">
        Welcome to Mobile Storehouse
      </h1>
      <div class="text-lg text-gray-200 max-w-2xl mt-8 mb-20">
        A B2B small wares and appliances marketplace designed for restaurant owners and&nbsp;franchisees.
      <msh-button 
        [cta]="'Get Started'"
        class="w-full mt-5"
        (onClick)="getStartedClick($event)"
      >
      </msh-button>
      </div>
    </div>
    <div class="flex flex-col items-center text-center px-6 py-12">



      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl w-full mb-10">
        <div class=" border border-copy/50 rounded-2xl p-6 shadow-sm text-left">
          <h2 class="text-xl font-semibold text-orange-400 mb-3">Sell Excess Stock</h2>
          <p class="text-copy leading-relaxed">
            Post your extra small wares and equipment to reach other qualified buyers in the food service industry.
          </p>
        </div>

        <div class=" border border-copy/50 rounded-2xl p-6 shadow-sm text-left">
          <h2 class="text-xl font-semibold text-orange-400 mb-3">Buy at Reduced Cost</h2>
          <p class="text-copy leading-relaxed">
            Find high-quality supplies at discounted rates from trusted peers in your network.
          </p>
        </div>
      </div>
    </div>
  `,
  styles: `
  .hero-image {position: relative; z-index: 1; top:-15px; background-color: black; }
  .hero-image::before {
  content: ""; /* Required for pseudo-elements */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('public/hero-image.jpg');
  background-position: center;
  background-size: cover; 
 
  opacity: 0.4; 
  z-index: -1; /* Puts the pseudo-element behind the content */ 
  }
  `,
  imports: [ButtonComponent],
  
})
export class HomeComponent {
  btnOptions: ButtonOption[] = [
    {cta: "Cancel", fn: ()=>{console.log('cancel')}, disabled: false},
    {cta: "Message", fn: this.message, disabled: true},
    {cta: "Refund", fn: ()=>{console.log('Refund')}},
  ];

  constructor(private snackBar: MatSnackBar,
    private router: Router,
    private store: Store
  ){}

  message(){
    console.log('message')
  }

  async getStartedClick(ev: any){
    const user = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(take(1)));
    if(user) {
      this.router.navigate(["/listing"])
      return;
    }
    this.router.navigate(["/signup"])
  }
}
